import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-nabar-home',
  templateUrl: './nabar-home.component.html',
  styleUrls: ['./nabar-home.component.scss']
})
export class NabarHomeComponent implements OnInit {
  navbarOpen = false;
  currentLanguage: string;

  constructor(public languageService: LanguageService,private router: Router) { 
    this.currentLanguage = languageService.getCurrentLanguage();
    
  }
  changeLanguage(lang: string) {
    this.languageService.setLanguage(lang);
    this.currentLanguage = lang;
  }
  ngOnInit(): void {
  }

  setNavbarOpen() {
    this.navbarOpen = !this.navbarOpen;
  }

  isCurrentRoute(route: string): boolean {
    return this.router.url === route;
  }

}
